import { MapPin, Star } from "lucide-react";
import { Button } from "@/components/ui/button";

const destinations = [
  {
    name: "Bali, Indonesia",
    image: "https://images.pexels.com/photos/2474689/pexels-photo-2474689.jpeg",
    rating: 4.9,
    reviews: 850,
    price: "From $1,299",
    tag: "Popular",
    span: "lg:col-span-2 lg:row-span-2"
  },
  {
    name: "Fiji Islands",
    image: "https://images.pexels.com/photos/1174732/pexels-photo-1174732.jpeg",
    rating: 4.8,
    reviews: 620,
    price: "From $1,599",
    tag: "Trending",
    span: ""
  },
  {
    name: "Maldives",
    image: "https://images.pexels.com/photos/1287460/pexels-photo-1287460.jpeg",
    rating: 5.0,
    reviews: 1200,
    price: "From $2,199",
    tag: "Luxury",
    span: ""
  },
  {
    name: "Santorini, Greece",
    image: "https://images.pexels.com/photos/1010657/pexels-photo-1010657.jpeg",
    rating: 4.9,
    reviews: 940,
    price: "From $1,899",
    tag: "Romantic",
    span: ""
  },
  {
    name: "Queenstown, NZ",
    image: "https://images.pexels.com/photos/547050/pexels-photo-547050.jpeg",
    rating: 4.8,
    reviews: 580,
    price: "From $1,199",
    tag: "Adventure",
    span: ""
  },
  {
    name: "Phuket, Thailand",
    image: "https://images.pexels.com/photos/1450353/pexels-photo-1450353.jpeg",
    rating: 4.7,
    reviews: 720,
    price: "From $999",
    tag: "Budget-Friendly",
    span: ""
  }
];

export default function Destinations() {
  const scrollToContact = () => {
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="destinations" className="py-20 bg-sky-50" data-testid="destinations-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-sky-200 text-sky-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            Popular Destinations
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-sky-900 mb-4">
            Explore Our Top Destinations
          </h2>
          <p className="text-sky-600 max-w-2xl mx-auto text-lg">
            Discover breathtaking locations handpicked by our travel experts for unforgettable experiences.
          </p>
        </div>

        {/* Destinations Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {destinations.map((destination, index) => (
            <div 
              key={index} 
              className={`group relative rounded-2xl overflow-hidden shadow-lg hover-lift ${destination.span || ""}`}
              data-testid={`destination-card-${index}`}
            >
              {/* Image */}
              <img
                src={destination.image}
                alt={destination.name}
                className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                  index === 0 ? "h-full min-h-[400px]" : "h-64"
                }`}
              />
              
              {/* Solid overlay */}
              <div className="absolute inset-0 bg-sky-900/50 transition-opacity group-hover:bg-sky-900/60"></div>

              {/* Tag */}
              <div className="absolute top-4 left-4">
                <span className="bg-yellow-400 text-sky-900 px-3 py-1 rounded-full text-sm font-medium">
                  {destination.tag}
                </span>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <div className="flex items-center gap-1 mb-2">
                  <Star className="fill-yellow-400 text-yellow-400" size={16} />
                  <span className="font-medium">{destination.rating}</span>
                  <span className="text-sky-200 text-sm">({destination.reviews} reviews)</span>
                </div>
                
                <h3 className="text-xl font-bold mb-1 flex items-center gap-2">
                  <MapPin size={18} />
                  {destination.name}
                </h3>
                
                <div className="flex items-center justify-between">
                  <span className="text-sky-100 font-medium">{destination.price}</span>
                  <Button 
                    onClick={scrollToContact}
                    size="sm"
                    className="bg-white text-sky-700 hover:bg-sky-50 opacity-0 group-hover:opacity-100 transition-opacity"
                    data-testid={`destination-book-${index}`}
                  >
                    Book Now
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-12">
          <Button 
            onClick={scrollToContact}
            variant="outline"
            className="border-sky-600 text-sky-600 hover:bg-sky-100 px-8"
            data-testid="view-all-destinations-btn"
          >
            View All Destinations
          </Button>
        </div>
      </div>
    </section>
  );
}
